// Scroll to Yotpo reviews section when clicking on star rating (ADA theme)
(function() {
  const handledElements = new WeakSet();

  // Get header height (fallback to 60px if not found)
  function getHeaderHeight() {
    const header =
      document.querySelector('#header-component') ||
      document.querySelector('header');

    if (header && header instanceof HTMLElement) {
      return header.offsetHeight || 60;
    }

    return 60;
  }

  // Scroll to reviews section
  function scrollToReviews() {
    const target =
      document.querySelector('#yotpo-reviews-main-widget') ||
      document.querySelector('.yotpo-reviews-main-widget');

    if (!target || !(target instanceof HTMLElement)) return;

    const targetTop =
      target.getBoundingClientRect().top +
      window.scrollY -
      getHeaderHeight() -
      10;

    window.scrollTo({
      top: targetTop,
      behavior: 'smooth',
    });
  }

  // Wait for Yotpo widget to be present and sized, then scroll
  function waitForWidgetAndScroll() {
    const widget =
      document.querySelector('#yotpo-reviews-main-widget') ||
      document.querySelector('.yotpo-reviews-main-widget');

    if (widget && widget instanceof HTMLElement && widget.offsetHeight > 50) {
      requestAnimationFrame(scrollToReviews);
      setTimeout(scrollToReviews, 500);
    } else {
      const observer = new MutationObserver(function() {
        const w =
          document.querySelector('#yotpo-reviews-main-widget') ||
          document.querySelector('.yotpo-reviews-main-widget');

        if (w && w instanceof HTMLElement && w.offsetHeight > 50) {
          observer.disconnect();
          requestAnimationFrame(scrollToReviews);
          setTimeout(scrollToReviews, 500);
        }
      });

      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  // Hash scroll on page load
  if (window.location.hash === '#yotpo-reviews-main-widget') {
    waitForWidgetAndScroll();
  }

  // Attach click handlers to Yotpo star rating elements
  function initYotpoScroll() {
    const starRatingElements = document.querySelectorAll(
      '[id*="yotpo_product_reviews_star_rating"]'
    );

    starRatingElements.forEach(function(element) {
      if (handledElements.has(element)) {
        return;
      }

      handledElements.add(element);

      element.addEventListener(
        'click',
        function() {
          waitForWidgetAndScroll();
        },
        true // capture phase
      );

      if (element instanceof HTMLElement) {
        element.style.cursor = 'pointer';
      }
    });
  }

  // Track fixed links to avoid duplicate handlers
  const fixedLinks = new WeakSet();

  // Fix uncrawlable links (javascript:void(0)) related to reviews
  function fixUncrawlableLinks() {
    const uncrawlableLinks = document.querySelectorAll(
      'a[href="javascript:void(0)"], a[href="javascript:void(0);"]'
    );

    uncrawlableLinks.forEach(function(link) {
      if (fixedLinks.has(link)) {
        return;
      }

      const ariaLabel = link.getAttribute('aria-label') || '';
      const isInYotpoWidget = link.closest(
        '#yotpo-reviews-main-widget, .yotpo-reviews-main-widget, [id*="yotpo"], .yotpo'
      );

      if (ariaLabel.toLowerCase().includes('review') || isInYotpoWidget) {
        link.setAttribute('href', '#yotpo-reviews-main-widget');
        fixedLinks.add(link);

        link.addEventListener('click', function(e) {
          e.preventDefault();
          waitForWidgetAndScroll();
        });
      }
    });
  }

  // Init on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initYotpoScroll();
      fixUncrawlableLinks();
    });
  } else {
    initYotpoScroll();
    fixUncrawlableLinks();
  }

  // Watch for dynamically added content (Yotpo injects widgets later)
  const starRatingObserver = new MutationObserver(function() {
    initYotpoScroll();
    fixUncrawlableLinks();
  });

  starRatingObserver.observe(document.body, {
    childList: true,
    subtree: true,
  });

  // Extra periodic fix for late-loaded widgets
  setTimeout(fixUncrawlableLinks, 1000);
  setTimeout(fixUncrawlableLinks, 3000);
})();

